<template>
    <div style="height: 100%;">
        <detail :detailId="detailId"></detail>
    </div>
</template>
<script>
    import detail from '@/views/order/detail/detail.vue'
    export default {
        name: 'agentDetailView',
        data () {
            return {
                detailId:this.$route.query.id,
            }
        },
        components: {
            detail
        }
    }
</script>
<style scoped>

</style>
